module.exports = __webpack_public_path__ + "static/fipcrosebunny2-4cc78c0a0b7e9959e385dc0c33286d87.jpeg";